import * as React from 'react'
function SvgSave(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M20 4C11.2 4 4 11.2 4 20s7.2 16 16 16 16-7.2 16-16S28.8 4 20 4zm0 20c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-16c1.8 0 3.6.4 5.2 1.2l-3.112 3.112c-1.522-.414-2.654-.414-4.178 0L14.8 9.2C16.4 8.4 18.2 8 20 8zM8 20c0-1.8.4-3.6 1.2-5.2l3.112 3.112c-.414 1.522-.414 2.654 0 4.178L9.2 25.2C8.4 23.6 8 21.8 8 20zm12 12c-1.8 0-3.6-.4-5.2-1.2l3.112-3.112c1.522.414 2.654.414 4.178 0L25.2 30.8c-1.6.8-3.4 1.2-5.2 1.2zm10.8-6.8l-3.112-3.112c.414-1.522.414-2.654 0-4.178L30.8 14.8c.8 1.6 1.2 3.4 1.2 5.2 0 1.8-.4 3.6-1.2 5.2z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgSave
